import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[DocumentType SetFilter] Action',
  ResetFilter: '[DocumentType ResetFilter] Action',
}

const initialDocumentTypeState: IDocumentTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IDocumentTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-DocumentType', whitelist: ['filter']},
  (
    state: IDocumentTypeState = initialDocumentTypeState,
    action: ActionWithPayload<IDocumentTypeState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialDocumentTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
